import React, { PureComponent, ReactNode } from 'react';
import Wizard from '../../Wizard';
import { pageview } from '../../../lib/analytics';
import InsuranceDetailFields, { validate } from './InsuranceDetailFields';

class InsuranceDetail extends PureComponent<{}> {
  componentDidMount() {
    pageview('/insurance-detail');
  }

  render(): ReactNode {
    return (
      <Wizard.Page validate={validate}>
        <InsuranceDetailFields />
      </Wizard.Page>
    );
  }
}

export default InsuranceDetail;
